import { Component, OnInit } from '@angular/core';
import {DataserviceService} from '../../dataservice.service';
import { ActivatedRoute } from "@angular/router";
import {Router} from '@angular/router';

import { HttpErrorResponse } from '@angular/common/http';
import Swal from 'sweetalert2';



@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.css']
})
export class ResetComponent implements OnInit {
  model:any={};
  passToken:String;

  constructor(private dataservice:DataserviceService,private route: ActivatedRoute,private router:Router) {
    this.route.queryParams.subscribe(params => {this.passToken = params.token});
console.log(this.passToken);

   }

  ngOnInit() {
  }






  resetPass(){
    console.log(this.model);
    if(this.model.newPass == this.model.confirmPass){

    
    this.dataservice.resetPass1(this.model,this.passToken).subscribe(
      data=>{
        console.log(data);
        this.router.navigate(['']);

        
      },
      (err : HttpErrorResponse)=>{
        console.log(err.error.error_description);

        Swal(err.error.error_description);
       
      }
    )
    }
    else{
      Swal("New password and old password should be same");
    }




  }
}
